var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeopleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.579 25.562a1.499 1.499 0 01-.927-1.388v-.345c1.145-.766 1.949-2.55 1.949-4.63a3.2 3.2 0 00-6.4 0c0 2.08.803 3.864 1.948 4.63v.345a1.496 1.496 0 01-.927 1.388l-4.221 1.747-4.222-1.747a1.498 1.498 0 01-.927-1.388v-.345c1.145-.765 1.948-2.55 1.948-4.63a3.2 3.2 0 10-6.4 0c0 2.08.804 3.865 1.948 4.63v.345a1.496 1.496 0 01-.927 1.388L3.2 27.309v1.49h25.6v-1.49l-4.221-1.747z",
    stroke: "#836F50",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.724 15.152a1.871 1.871 0 01-1.159-1.734v-.431C18.997 12.03 20 9.799 20 7.2a4 4 0 10-8 0c0 2.598 1.005 4.829 2.436 5.786v.43a1.871 1.871 0 01-1.158 1.735l-2.551 1.056A3.198 3.198 0 0112.8 19.2h6.4c0-1.37.864-2.536 2.074-2.992l-2.55-1.056z",
    stroke: "#836F50",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/people-icon.7ccef54e57e1a47e60a063b867180112.svg";
export { ForwardRef as ReactComponent };